/*
  AMZ Testimonials Fallback Slider
  - Makes the testimonials section visible + swipeable even when ApxSlider is not present.
  - Uses native horizontal scrolling + scroll-snap.
  - Adds clickable dots.
*/
(function(){
  // IMPORTANT:
  // We run this fallback even if ApxSlider exists because in some Apex builds
  // ApxSlider can be present but the testimonials slider may fail to initialize,
  // leaving the section blank due to default CSS that hides slides.
  // We only apply the fallback when the slider has NOT been initialized.

  function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

  function closestSlideIndex(slider, slides){
    var rect = slider.getBoundingClientRect();
    var center = rect.left + rect.width / 2;
    var bestIdx = 0;
    var bestDist = Infinity;
    for (var i=0;i<slides.length;i++){
      var r = slides[i].getBoundingClientRect();
      var c = r.left + r.width / 2;
      var d = Math.abs(c - center);
      if (d < bestDist){ bestDist = d; bestIdx = i; }
    }
    return bestIdx;
  }

  function scrollToSlide(slider, slide){
    if (!slide) return;
    var sliderRect = slider.getBoundingClientRect();
    var slideRect = slide.getBoundingClientRect();
    // Scroll so slide center aligns with slider center
    var delta = (slideRect.left + slideRect.width/2) - (sliderRect.left + sliderRect.width/2);
    slider.scrollLeft += delta;
  }

  function initOne(section){
    var slider = section.querySelector('.testimonials-slider');
    if (!slider || slider.dataset.amzTsInit === '1') return;

    if (
      section.hasAttribute('data-amz-swiper-mode') ||
      slider.hasAttribute('data-amz-swiper-mode') ||
      slider.classList.contains('swiper-initialized')
    ) {
      return;
    }

    // If ApxSlider has already initialized/wrapped it, leave it alone
    if (
      slider.classList.contains('amz-fc-on') ||
      slider.querySelector('.amz-fc-view') ||
      slider.querySelector('.amz-fc-track') ||
      slider.closest('.amz-fc-view') ||
      slider.querySelector('.amz-fc-track')
    ) {
      return;
    }

    var slides = Array.prototype.slice.call(slider.querySelectorAll('.testimonials-slide'));
    if (!slides.length) return;

    slider.dataset.amzTsInit = '1';
    slider.classList.add('amz-ts-ready');

    // Improve touch/drag behavior and prevent text selection while dragging
    slider.style.touchAction = 'pan-x';
    slider.style.userSelect = 'none';

    // Ensure slides are not hidden by default CSS
    slides.forEach(function(s){
      s.style.display = 'block';
      s.style.opacity = '1';
    });

    // Dots
    var dotsWrap = section.querySelector('[data-amz-ts-dots]');
    var dots = [];
    if (dotsWrap && slides.length > 1) {
      dotsWrap.innerHTML = '';
      for (var i=0;i<slides.length;i++){
        (function(idx){
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'amz-ts-dot' + (idx === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Go to testimonial ' + (idx+1));
          b.addEventListener('click', function(){
            scrollToSlide(slider, slides[idx]);
            setActive(idx);
          });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
    }

    function setActive(idx){
      idx = clamp(idx, 0, slides.length-1);
      slides.forEach(function(s, i){
        if (i === idx) s.classList.add('is-selected');
        else s.classList.remove('is-selected');
      });
      if (dots.length){
        dots.forEach(function(d, i){
          if (i === idx) d.classList.add('is-active');
          else d.classList.remove('is-active');
        });
      }
    }

    // Initial active
    setActive(0);

    // Update active on scroll (throttled)
    var ticking = false;
    slider.addEventListener('scroll', function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        var idx = closestSlideIndex(slider, slides);
        setActive(idx);
      });
    }, { passive: true });

    // Desktop drag-to-scroll support (mouse/pen). Touch devices use native scrolling.
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var didDrag = false;
    slider.addEventListener('pointerdown', function(e){
      // Only left click
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Let touch devices use native scrolling
      if (e.pointerType === 'touch') return;
      isDown = true;
      didDrag = false;
      startX = e.clientX;
      startScroll = slider.scrollLeft;
      slider.classList.add('amz-ts-dragging');
      slider.setPointerCapture && slider.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    slider.addEventListener('pointermove', function(e){
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) didDrag = true;
      slider.scrollLeft = startScroll - dx;
      e.preventDefault();
    });
    function endDrag(){
      isDown = false;
      slider.classList.remove('amz-ts-dragging');
      // prevent accidental click after drag
      if (didDrag) {
        var once = function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          slider.removeEventListener('click', once, true);
        };
        slider.addEventListener('click', once, true);
      }
    }
    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
  }

  function initAll(root){
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-apx-section="testimonials"]');
    sections.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
